<p-toast position="top-right" key="tc"></p-toast>

<div class="mb-2 flex align-items-center justify-content-between">
    <div class="flex align-items-center">
        <i class="pi pi-barcode text-500 mr-2 text-xl"></i>
        <span class="text-xl font-medium text-900">Charge Scan</span>
    </div>
</div>
@if(loading) {
<!-- ... loading indicator ... -->
<p-divider></p-divider>
<div class="mb-2 flex align-items-center justify-content-between">
    <div class="flex align-items-center">
        <i class="pi pi-barcode text-500 mr-2 text-xl"></i>
        <span class=" font-medium text-900">Chargen werden geladen, bitte warten!</span>
    </div>
</div>
<div class="loading-container">
    <div class="loading-centered-element"><i class="pi pi-spin pi-spinner" style="font-size: 5rem"></i></div>
</div>
}
<p-divider></p-divider>
<div>

    <!-- Bind the form group and add submit handler -->
    <!-- Use grid directly on the form for layout -->
    <form [formGroup]="chargeForm" (ngSubmit)="saveCharge()" class="p-fluid grid formgrid mt-3">

        <!-- BA-Nr. -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="banr">BA-Nr.</label>
            <p-inputGroup>
                <input id="banr" pInputText type="text" formControlName="banr" class="w-full"
                       [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('banr')}">
                <button type="button" pButton icon="pi pi-barcode" class="p-button-secondary"
                        (click)="startScanFor('banr')" [disabled]="scannerService.isScanning()"></button>
            </p-inputGroup>
            @if (isControlInvalid('banr')) {
                <small class="p-error">
                    @if (chargeForm.controls['banr'].errors?.['required']) {
                        BA-Nr. ist ein Pflichtfeld.
                    }
                </small>
            }
        </div>

        <!-- Mitarbeiter-Nr. -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="mitarbeiternr">Mitarbeiter-Nr.</label>
            <p-inputGroup>
                <input id="mitarbeiternr" pInputText type="text" formControlName="mitarbeiternr" class="w-full"
                       [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('mitarbeiternr')}">
                <button type="button" pButton icon="pi pi-barcode" class="p-button-secondary"
                        (click)="startScanFor('mitarbeiternr')" [disabled]="scannerService.isScanning()"></button>
            </p-inputGroup>
             @if (isControlInvalid('mitarbeiternr')) {
                <small class="p-error">
                     @if (chargeForm.controls['mitarbeiternr'].errors?.['required']) {
                        Mitarbeiter-Nr. ist ein Pflichtfeld.
                     }
                </small>
             }
        </div>

        <!-- Datum -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="datum">Datum</label>
            <!-- Use p-calendar -->
            <p-calendar id="datum" formControlName="datum" [showIcon]="true" inputId="datum_input" dateFormat="dd.mm.yy" styleClass="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('datum')}"></p-calendar>
             @if (isControlInvalid('datum')) {
                <small class="p-error">
                     @if (chargeForm.controls['datum'].errors?.['required']) {
                        Datum ist ein Pflichtfeld.
                     }
                </small>
             }
        </div>

        <!-- Fertigungsmenge -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="fertigungsmenge">Fertigungsmenge</label>
            <!-- Use pInputText with type="number" or p-inputNumber -->
            <input id="fertigungsmenge" pInputText type="number" formControlName="fertigungsmenge" class="w-full"
                   [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('fertigungsmenge')}">
            <!-- Alternative: <p-inputNumber inputId="fertigungsmenge" formControlName="fertigungsmenge" mode="decimal" [useGrouping]="false" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('fertigungsmenge')}"></p-inputNumber> -->
             @if (isControlInvalid('fertigungsmenge')) {
                <small class="p-error">
                     @if (chargeForm.controls['fertigungsmenge'].errors?.['required']) {
                        Fertigungsmenge ist ein Pflichtfeld.
                     }
                     @if (chargeForm.controls['fertigungsmenge'].errors?.['pattern']) {
                        Bitte nur Zahlen eingeben.
                     }
                </small>
             }
        </div>

        <!-- Material-Nr. -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="materialnr">Material-Nr.</label>
            <p-inputGroup>
                <input id="materialnr" pInputText type="text" formControlName="materialnr" class="w-full"
                       [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('materialnr')}">
                <button type="button" pButton icon="pi pi-barcode" class="p-button-secondary"
                        (click)="startScanFor('materialnr')" [disabled]="scannerService.isScanning()"></button>
            </p-inputGroup>
             @if (isControlInvalid('materialnr')) {
                <small class="p-error">
                     @if (chargeForm.controls['materialnr'].errors?.['required']) {
                        Material-Nr. ist ein Pflichtfeld.
                     }
                </small>
             }
        </div>

        <!-- Material Batch-Nr. -->
        <div class="field col-12 md:col-6 lg:col-4">
            <label for="material_batchnr">Material Batch-Nr.</label>
            <p-inputGroup>
                <input id="material_batchnr" pInputText type="text" formControlName="material_batchnr" class="w-full"
                       [ngClass]="{'ng-invalid ng-dirty': isControlInvalid('material_batchnr')}">
                <button type="button" pButton icon="pi pi-barcode" class="p-button-secondary"
                        (click)="startScanFor('material_batchnr')" [disabled]="scannerService.isScanning()"></button>
            </p-inputGroup>
             @if (isControlInvalid('material_batchnr')) {
                <small class="p-error">
                     @if (chargeForm.controls['material_batchnr'].errors?.['required']) {
                        Material Batch-Nr. ist ein Pflichtfeld.
                     }
                </small>
             }
        </div>

        <!-- Save Buttons Container -->
        <!-- Use grid utilities for alignment and spacing -->
        <div class="col-12 flex justify-content-end gap-2 mt-4">
             <!-- Save and New Button -->
             <button type="button" pButton label="Speichern und neu scannen" icon="pi pi-save" class="p-button-success" (click)="saveAndScanNew()"></button>
             <!-- Save and Finish Button (triggers form submit) -->
             <button type="submit" pButton label="Speichern und fertig" icon="pi pi-check" class="p-button-primary" (click)="saveAndClose()"></button>
        </div>

    </form> <!-- Close the form tag -->

</div>

<!-- Scanner Modal -->
@if (scannerService.isScanning()) {
    <div class="preview-modal-overlay">
        <div class="preview-modal-content">
            <h4>Barcode scannen für {{ scannerService.currentScanTarget() }}</h4>

            @if (scannerService.isLoadingDevices()) {
                <div class="info-message">Suche nach Kameras...</div>
            }

            @if (!scannerService.isLoadingDevices() && scannerService.hasDevices()) {
                <div class="device-selection">
                    @if (scannerService.availableDevices().length > 1) {
                        <label for="device-select">Kamera:</label>
                        <select id="device-select" (change)="changeDevice($event)">
                            @for (device of scannerService.availableDevices(); track device.deviceId) {
                                <option [value]="device.deviceId" [selected]="scannerService.currentDevice()?.deviceId === device.deviceId">
                                    {{ device.label || ('Kamera ' + (scannerService.availableDevices().indexOf(device) + 1)) }}
                                </option>
                            }
                        </select>
                    }
                </div>
            }

             @if (!scannerService.isLoadingDevices() && !scannerService.hasDevices() && scannerService.hasPermission()) {
                <div class="info-message error-message">Keine Kamera gefunden.</div>
             }
             @if (!scannerService.hasPermission()) {
                <div class="info-message">Warte auf Kameraberechtigung...</div>
             }

            @if (scannerService.hasPermission()) {
                <zxing-scanner
                    class="scanner-preview"
                    [device]="scannerService.currentDevice()"
                    (scanSuccess)="onScanSuccessHandler($event)"
                    (scanError)="onScanErrorHandler($event)"
                    (camerasFound)="onCamerasFoundHandler($event)"
                    (permissionResponse)="onPermissionResponseHandler($event)"
                    [formats]="allowedFormats">
                </zxing-scanner>
            }

            @if (scannerService.scanError(); as error) {
                <div class="error-message">Fehler: {{ error.message }}</div>
            }

            <button (click)="stopScan()" class="stop-button p-button p-button-danger mt-3">Abbrechen</button>
        </div>
    </div>
}